import React, { FC, useEffect } from 'react';
import { t } from 'i18next';
import moment from 'moment';
import { setHours, setMinutes } from 'date-fns';
import { useFormApi } from 'informed';
import { MultiSteps } from '@common/interfaces';
import { notEmptyValidator } from '@common/utils';
import { DateField } from '../../../../../legacyInputs';
import css from '../styles.module.scss';

const TIME_INTERVAL = 15;

const DropOffTimeReturnField: FC = () => {
  const formApi = useFormApi();
  const pickup_time_return = formApi.getValue(
    `${MultiSteps.ReturnTrip}.pickup_time_return`,
  ) as string;
  const pickup_date_return = formApi.getValue(
    `${MultiSteps.ReturnTrip}.pickup_date_return`,
  ) as string;
  const dropoff_date_return = formApi.getValue(
    `${MultiSteps.ReturnTrip}.dropoff_date_return`,
  ) as string;

  const isSameDate = moment(pickup_date_return).isSame(dropoff_date_return, 'day');
  const minEndTime = moment(pickup_time_return).add(TIME_INTERVAL, 'minutes');

  useEffect(() => {
    if (pickup_time_return) {
      formApi.setValue(
        `${MultiSteps.ReturnTrip}.dropoff_time_return`,
        moment(pickup_time_return).add(TIME_INTERVAL, 'minutes').toDate(),
      );
    }
  }, [pickup_time_return]);

  return (
    <div className={css.field} data-testid="mobility-planner-edit-form-drop-off-time-return">
      <DateField
        className={css.input}
        dateFormat="HH:mm"
        label={t('bookingDetails.dropoffTime')}
        maxTime={isSameDate ? setHours(setMinutes(new Date(), 45), 23) : undefined}
        minTime={
          isSameDate
            ? setHours(setMinutes(new Date(), minEndTime.minutes()), minEndTime.hour())
            : undefined
        }
        name="dropoff_time_return"
        showTimeSelect
        showTimeSelectOnly
        timeCaption={undefined}
        timeFormat="HH:mm"
        timeIntervals={TIME_INTERVAL}
        validate={notEmptyValidator}
      />
    </div>
  );
};

export default DropOffTimeReturnField;
